import * as types from '../mutation-types'
import discountService from '../../services/discounts'

const state = {
    loading: false,
    errors: null,
    discounts: [],
}

const actions = {
    getAll({ commit }) {
        commit(types.DISCOUNT_LOADING, true)
        discountService.getAll().then(
            response => {

                commit(types.LOAD_DISCOUNTS, response.data)
                commit(types.DISCOUNT_LOADING, false)
                commit(types.DISCOUNT_FAILURE, null)
            },
            error => {
                commit(types.DISCOUNT_FAILURE, error)
                commit(types.DISCOUNT_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.DISCOUNT_LOADING, true)
        commit(types.DISCOUNT_FAILURE, null)
        discountService.add(data).then(
            response => {
                data.id = response.data.id
                commit(types.ADD_DISCOUNT, data)
                commit(types.DISCOUNT_LOADING, false)

            },
            error => {
                commit(types.DISCOUNT_FAILURE, error)
                commit(types.DISCOUNT_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.DISCOUNT_LOADING, true)
        commit(types.DISCOUNT_FAILURE, null)
        data.discount.roles = ["discount"]
        discountService.update(data.discount)
            .then(
                response => {
                    commit(types.UPDATE_DISCOUNT, data)
                    commit(types.DISCOUNT_LOADING, false)

                },
                error => {
                    commit(types.DISCOUNT_FAILURE, error)
                    commit(types.DISCOUNT_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.DISCOUNT_LOADING, true)
        commit(types.DISCOUNT_FAILURE, null)
        discountService.delete(data.discount.id)
            .then(
                response => {

                    commit(types.DELETE_DISCOUNT, data)
                    commit(types.DISCOUNT_LOADING, false)

                },
                error => {
                    commit(types.DISCOUNT_FAILURE, error)
                    commit(types.DISCOUNT_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_DISCOUNT](state, payload) {
        state.discounts.unshift(payload);
    },
    [types.LOAD_DISCOUNTS](state, payload) {
        state.discounts = payload
    },
    [types.UPDATE_DISCOUNT](state, payload) {
        Object.assign(state.discounts[payload.index], payload.discount);
    },
    [types.DELETE_DISCOUNT](state, payload) {
        state.discounts.splice(payload.index, 1)
    },
    [types.DISCOUNT_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.DISCOUNT_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    DISCOUNTS: state => {
        return state.discounts
    },

    DISCOUNT_ERROR: state => {
        return state.errors
    },

    DISCOUNT_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/discounts.js